import { SocketModule } from './DI/SocketModule';
import { DISocketTypes } from './DI/types';
import { ISocketClientFactoryMethod } from './DI/interfaces';

export {
  SocketModule,
  type ISocketClientFactoryMethod as ISocketClientFactory,
};

export const { SocketClient } = DISocketTypes;
